import React from 'react'
import * as S from '../styles'

export const Button = ({ title, onClick, ...rest }) => {
  return (
    <S.Button onClick={onClick} {...rest}>
      <S.Text>{title}</S.Text>
    </S.Button>
  )
}
